module.exports = "<div id=\"generic-notification-holder\" style=\"display: none\">\n    <%= feedback %>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./js/common/templates/notifications/LiveClassFeedbackNotificationWrapper.html
// module id = 1075
// module chunks = 26 27 28